import z from "zod";
export const cockBallsBindingStylesSchema = z.enum([
    "cock-balls-tie",
    "ball-seperation",
    "cock-ball-wrapping",
    "ball-wrapping",
]);
export const cockBallsBindingStyles = cockBallsBindingStylesSchema.options;
